var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArtboard50(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        clip-path: url(#clip-Artboard_50);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: none;\r\n        stroke: #8082d0;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 1.5px;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_50"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_50",
    "data-name": "Artboard \\u2013 50",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-message-circle",
    "data-name": "Icon feather-message-circle",
    className: "cls-2",
    d: "M15.583,9.733a5.16,5.16,0,0,1-.554,2.34,5.234,5.234,0,0,1-4.679,2.894,5.16,5.16,0,0,1-2.34-.554L4.5,15.583l1.17-3.51a5.16,5.16,0,0,1-.554-2.34A5.234,5.234,0,0,1,8.01,5.054a5.16,5.16,0,0,1,2.34-.554h.308a5.446,5.446,0,0,1,3.011,1.166,5.051,5.051,0,0,1,1.915,3.76Z",
    transform: "translate(-1.542 -2.042)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtboard50);
export default __webpack_public_path__ + "static/media/Artboard – 50.3025853d8d30e5ffdd532ee6d91da91c.svg";
export { ForwardRef as ReactComponent };